export default "/images/0fc706ea146f044fa7480225c8ffb1a5.png";